import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

// Paginator wording for the whole back office (provided in app.config):
// "Rows per page" and "1–10 of 54", with clear button tooltips.
@Injectable()
export class AppPaginatorIntl extends MatPaginatorIntl {
  static readonly DEFAULT_ITEMS_LABEL = 'Rows per page';

  override itemsPerPageLabel = AppPaginatorIntl.DEFAULT_ITEMS_LABEL;
  override firstPageLabel = 'First page';
  override lastPageLabel = 'Last page';
  override nextPageLabel = 'Next page';
  override previousPageLabel = 'Previous page';

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (!length || !pageSize) return '0 of 0';
    const start = page * pageSize + 1;
    const end = Math.min(length, (page + 1) * pageSize);
    return `${start.toLocaleString('en-GB')}–${end.toLocaleString('en-GB')} of ${length.toLocaleString('en-GB')}`;
  };
}
